import React from "react";
import { LeadsListView } from "../components/LeadsListView";
import { useAppStore } from "../store/useAppStore";

const DEMO_COMPANY_ID = "te-1";

export function ExhibitorLeadsPage() {
  const { selectedEventId } = useAppStore();

  return (
    <LeadsListView
      eventId={selectedEventId ?? "evt-1"}
      companyId={DEMO_COMPANY_ID}
      basePath="/exhibitor/leads"
      audience="visitor"
      direction="inbound"
      title="Вас сканировали"
    />
  );
}
